import {useMutation, gql} from '@apollo/client'

export const MUTATE_UPDATE_CLIENT = gql`
  mutation MUTATE_UPDATE_CLIENT($clientId: Int!, $clientName: Customname!) {
    updateClient(clientId: $clientId, clientName: $clientName) {
      updatedClientDetails {
        clientId
      }
    }
  }
`

export function useUpdateClientName() {
  return useMutation(MUTATE_UPDATE_CLIENT, {
    context: {clientName: 'adminPanel'}
  })
}
